import ApiService from "./ApiService";
export default class StoreService extends ApiService {
  constructor(endpointName) {
    super(endpointName);
  }
  getDashboard() {
    const _url = this.serviceUrl + this.endpoints.dashboard;
    return this.GET(_url);
  }

  getListStores({
    pageIndex,
    pageSize,
    searchTerm,
    sortAscending,
    sortBy,
    subscriptionId,
    isDeleted
  }) {
    let _url = this.serviceUrl + this.endpoints.listStores;
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (searchTerm) {
      _url += "&searchTerm=" + searchTerm;
    }
    if (sortAscending || sortAscending == false) {
      _url += "&sortAscending=" + sortAscending;
    }
    if (subscriptionId) {
      _url += "&subscriptionId=" + subscriptionId;
    }
    if (sortBy || sortBy == 0) {
      _url += "&sortBy=" + sortBy;
    }
    if (isDeleted || isDeleted == false) {
      _url += "&isDeleted=" + isDeleted;
    }
    return this.GET(_url);
  }

  storeSubscriptions({
    pageIndex,
    pageSize,
    transactionCode,
    subscriptionId,
    trackingNumber,
    phoneNumber,
  }) {
    let _url = this.serviceUrl + this.endpoints.storeSubscriptions;
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (transactionCode) {
      _url += "&transactionCode=" + transactionCode;
    }
    if (subscriptionId) {
      _url += "&subscriptionId=" + subscriptionId;
    }
    if (phoneNumber) {
      _url += "&phoneNumber=" + phoneNumber;
    }
    if (trackingNumber) {
      _url += "&trackingNumber=" + trackingNumber;
    }
    return this.GET(_url);
  }

  subscriptionFeatures() {
    const _url = this.serviceUrl + this.endpoints.subscriptionFeatures;
    return this.GET(_url);
  }

  subscriptionFeaturesUpdate(data) {
    const _url = this.serviceUrl + this.endpoints.subscriptionFeaturesUpdate;
    return this.POST(_url, data);
  }

  changeSubscription(id, data) {
    const _url =
      this.serviceUrl + this.endpoints.subscription.replace("{__id__}", id);
    return this.PUT(_url, data);
  }

  getStore(id) {
    const _url = this.serviceUrl + this.endpoints.store.replace("{__id__}", id);
    return this.GET(_url);
  }

  removeStore(id) {
    const _url = this.serviceUrl + this.endpoints.store.replace("{__id__}", id);
    return this.Delete(_url);
  }

  loginAsUser(data) {
    const _url = this.serviceUrl + this.endpoints.loginAsUser;
    return this.POST(_url, data);
  }

  changeUserPassword(data) {
    const _url = this.serviceUrl + this.endpoints.changeUserPassword;
    return this.PATCH(_url, data);
  }

  getCategoryIcon({ pageIndex, pageSize }) {
    let _url = this.serviceUrl + this.endpoints.categoryIcon;
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    return this.GET(_url);
  }

  createCategoryIcon(data) {
    const _url = this.serviceUrl + this.endpoints.categoryIcon;
    return this.POST(_url, data);
  }

  deleteCategoryIcon(data) {
    const _url = this.serviceUrl + this.endpoints.categoryIcon;
    return this.Delete(_url, data);
  }

  editCategoryIcon(data) {
    const _url = this.serviceUrl + this.endpoints.categoryIcon;
    return this.PUT(_url, data);
  }

  imageRequests({ pageIndex, pageSize }) {
    let _url = this.serviceUrl + this.endpoints.imageRequests;
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    return this.GET(_url);
  }

  pendingCategories({ pageIndex, pageSize }) {
    let _url = this.serviceUrl + this.endpoints.pendingCategories;
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    return this.GET(_url);
  }

  pendingLoyaltyLevels({ pageIndex, pageSize }) {
    let _url = this.serviceUrl + this.endpoints.pendingLoyaltyLevels;
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    return this.GET(_url);
  }

  pendingProducts({ pageIndex, pageSize }) {
    let _url = this.serviceUrl + this.endpoints.pendingProducts;
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    return this.GET(_url);
  }

  pendingStores({ pageIndex, pageSize }) {
    let _url = this.serviceUrl + this.endpoints.pendingStores;
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    return this.GET(_url);
  }

  imageRequestsChangeStatus(data) {
    const _url = this.serviceUrl + this.endpoints.imageRequestsChangeStatus;
    return this.POST(_url, data);
  }

  pendingCategoriesChangeStatus(data) {
    const _url = this.serviceUrl + this.endpoints.pendingCategoriesChangeStatus;
    return this.POST(_url, data);
  }

  pendingLoyaltyLevelsChangeStatus(data) {
    const _url = this.serviceUrl + this.endpoints.pendingLoyaltyLevelsChangeStatus;
    return this.POST(_url, data);
  }

  pendingProductsChangeStatus(data) {
    const _url = this.serviceUrl + this.endpoints.pendingProductsChangeStatus;
    return this.POST(_url, data);
  }

  pendingStoresChangeStatus(data) {
    const _url = this.serviceUrl + this.endpoints.pendingStoresChangeStatus;
    return this.POST(_url, data);
  }

  subscriptionRenewal(id, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.subscriptionRenewal.replace("{__id__}", id);
    return this.POST(_url, data);
  }
  clearDailyVisits(id, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.clearDailyVisits.replace("{__id__}", id);
    return this.PATCH(_url, data);
  }
  createStore(data) {
    const _url = this.serviceUrl + this.endpoints.createStore;
    return this.POST(_url, data);
  }

  getTickets({ pageIndex, pageSize, searchTerm, status, id }) {
    let _url = this.serviceUrl + this.endpoints.getTickets;
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (searchTerm) {
      _url += "&SearchTerm=" + searchTerm;
    }
    if (status || status == 0) {
      _url += "&Status=" + status;
    }
    if (id) {
      _url += "&Id=" + id;
    }
    return this.GET(_url);
  }

  getDetailsTickets(id) {
    const _url =
      this.serviceUrl +
      this.endpoints.getDetailsTickets.replace("{__id__}", id);
    return this.GET(_url);
  }

  replyTicket(id, data) {
    const _url =
      this.serviceUrl + this.endpoints.replyTicket.replace("{__id__}", id);
    return this.POST(_url, data);
  }

  closeTicket(id) {
    const _url =
      this.serviceUrl + this.endpoints.closeTicket.replace("{__id__}", id);
    return this.PUT(_url);
  }

  getEconomicInfo({
    pageIndex,
    pageSize,
    storeName,
    status,
    adminPhoneNumber,
  }) {
    let _url = this.serviceUrl + this.endpoints.economicInfo;
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (storeName) {
      _url += "&StoreName=" + storeName;
    }
    if (adminPhoneNumber) {
      _url += "&AdminPhoneNumber=" + adminPhoneNumber;
    }
    if (status || status == 0) {
      _url += "&Status=" + status;
    }
    return this.GET(_url);
  }

  economicInfoDetails(id) {
    const _url =
      this.serviceUrl +
      this.endpoints.economicInfoDetails.replace("{__id__}", id);
    return this.GET(_url);
  }

  economicInfoReject(id, data) {
    const _url =
      this.serviceUrl +
      this.endpoints.economicInfoReject.replace("{__id__}", id);
    return this.POST(_url, data);
  }
  economicInfoAccept(id) {
    const _url =
      this.serviceUrl +
      this.endpoints.economicInfoAccept.replace("{__id__}", id);
    return this.POST(_url);
  }

  onlinePayments({
    pageIndex,
    pageSize,
    storeId,
    status,
    transactionCode,
    storeOrderNumber,
  }) {
    let _url = this.serviceUrl + this.endpoints.onlinePayments;
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (storeId) {
      _url += "&StoreId=" + storeId;
    }
    if (status || status == 0) {
      _url += "&Status=" + status;
    }
    if (transactionCode) {
      _url += "&TransactionCode=" + transactionCode;
    }
    if (storeOrderNumber) {
      _url += "&StoreOrderNumber=" + storeOrderNumber;
    }
    return this.GET(_url);
  }

  allOrders({
    pageIndex,
    pageSize,
    from,
    to,
    customerPhoneNumber,
    transactionCode,
    orderId,
    storeOrderNumber,
    storeId,
    paymentMethod,
    isReturned,
    hasTax,
    type,
  }) {
    let _url = this.serviceUrl + this.endpoints.allOrders;
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (from) {
      _url += "&From=" + from;
    }
    if (to) {
      _url += "&To=" + to;
    }
    if (customerPhoneNumber) {
      _url += "&CustomerPhoneNumber=" + customerPhoneNumber;
    }
    if (transactionCode) {
      _url += "&TransactionCode=" + transactionCode;
    }
    if (orderId) {
      _url += "&OrderId=" + orderId;
    }
    if (storeOrderNumber) {
      _url += "&StoreOrderNumber=" + storeOrderNumber;
    }
    if (storeId) {
      _url += "&StoreId=" + storeId;
    }
    if (paymentMethod || paymentMethod == 0) {
      _url += "&PaymentMethod=" + paymentMethod;
    }
    if (isReturned || isReturned == false) {
      _url += "&IsReturned=" + isReturned;
    }
    if (hasTax || hasTax == false) {
      _url += "&HasTax=" + hasTax;
    }
    if (type || type == 0) {
      _url += "&Type=" + type;
    }
    return this.GET(_url);
  }

  reportOrders({
    pageIndex,
    pageSize,
    from,
    to,
    storeId,
    paymentMethod,
    type,
  }) {
    let _url = this.serviceUrl + this.endpoints.reportOrders;
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (from) {
      _url += "&From=" + from;
    }
    if (to) {
      _url += "&To=" + to;
    }
    if (storeId) {
      _url += "&StoreId=" + storeId;
    }
    if (paymentMethod || paymentMethod == 0) {
      _url += "&PaymentMethod=" + paymentMethod;
    }
    if (type || type == 0) {
      _url += "&Type=" + type;
    }
    return this.GET(_url);
  }

  getCustomers({
    pageIndex,
    pageSize,
    phoneNumber,
    searchTerm,
    sortBy,
    levelNumber,
    sortDescending,
    minScore,
    maxScore,
    groupId,
    maxTotalOrdersCount,
    minTotalOrdersCount,
    maxTotalOrdersAmount,
    minTotalOrdersAmount,
    maxDaysNumberSinceLastOrdered,
    minDaysNumberSinceLastOrdered,
    storeId
  }) {
    let _url = this.serviceUrl + this.endpoints.customers;
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (phoneNumber) {
      _url += "&PhoneNumber=" + phoneNumber;
    }
    if (searchTerm) {
      _url += "&SearchTerm=" + searchTerm;
    }
    if (storeId) {
      _url += "&StoreId=" + storeId;
    }
    if (groupId) {
      _url += "&GroupId=" + groupId;
    }
    if (maxTotalOrdersCount) {
      _url += "&TotalOrdersCountRange.To=" + maxTotalOrdersCount;
    }
    if (minTotalOrdersCount) {
      _url += "&TotalOrdersCountRange.From=" + minTotalOrdersCount;
    }
    if (maxTotalOrdersAmount) {
      _url += "&TotalOrdersAmountRange.To=" + maxTotalOrdersAmount;
    }
    if (minTotalOrdersAmount) {
      _url += "&TotalOrdersAmountRange.From=" + minTotalOrdersAmount;
    }
    if (maxDaysNumberSinceLastOrdered) {
      _url += "&DaysNumberSinceLastOrderedRange.To=" + maxDaysNumberSinceLastOrdered;
    }
    if (minDaysNumberSinceLastOrdered) {
      _url += "&DaysNumberSinceLastOrderedRange.From=" + minDaysNumberSinceLastOrdered;
    }
    if (sortBy || sortBy == 0) {
      _url += "&SortBy=" + sortBy;
    }
    if (levelNumber) {
      _url += "&LevelNumber=" + levelNumber;
    }
    if (sortDescending || sortDescending == false) {
      _url += "&SortDescending=" + sortDescending;
    }
    if (minScore) {
      _url += "&ScoreRange.From=" + minScore;
    }
    if (maxScore) {
      _url += "&ScoreRange.To=" + maxScore;
    }
    return this.GET(_url);
  }

  customerOrders(id, { pageIndex, pageSize }) {
    let _url =
      this.serviceUrl + this.endpoints.customerOrders.replace("{__id__}", id);
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    return this.GET(_url);
  }

  userManagment({ pageIndex, pageSize, roleId }) {
    let _url = this.serviceUrl + this.endpoints.userManagment;
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (roleId) {
      _url += "&RoleId=" + roleId;
    }
    return this.GET(_url);
  }

  userManagmentRoles() {
    const _url = this.serviceUrl + this.endpoints.userManagmentRoles;
    return this.GET(_url);
  }

  smsManagement() {
    const _url = this.serviceUrl + this.endpoints.smsManagement;
    return this.GET(_url);
  }
  smsManagementStore(storeId) {
    let _url = this.serviceUrl + this.endpoints.smsManagementStore;
    if (storeId) {
      _url += "?StoreId=" + storeId;
    }
    return this.GET(_url);
  }
  editSmsTemplates(data) {
    const _url = this.serviceUrl + this.endpoints.smsManagement;
    return this.POST(_url, data);
  }

  getSmsChargesHistory({ pageIndex, pageSize, searchTerm }) {
    let _url = this.serviceUrl + this.endpoints.smsChargesHistory;
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (searchTerm) {
      _url += "&SearchTerm=" + searchTerm;
    }
    return this.GET(_url);
  }

  createNewUser(data) {
    const _url = this.serviceUrl + this.endpoints.createNewUser;
    return this.POST(_url, data);
  }
  smsManagementStoreAccept(data) {
    const _url = this.serviceUrl + this.endpoints.smsManagementStoreAccept;
    return this.POST(_url, data);
  }
  updateUser(id, data) {
    const _url = this.serviceUrl + this.endpoints.updateUser.replace("{__id__}", id);
    return this.PUT(_url, data);
  }
  sentMessagesHistory(
    { pageIndex, pageSize, phoneNumber, dateRangeFrom, dateRangeTo, storeId }
  ) {
    let _url =
      this.serviceUrl +
      this.endpoints.sentMessagesHistory;
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (storeId) {
      _url += "&StoreId=" + storeId;
    }
    if (phoneNumber) {
      _url += "&PhoneNumber=" + phoneNumber;
    }
    if (dateRangeFrom) {
      _url += "&DateRange.From=" + dateRangeFrom;
    }
    if (dateRangeTo) {
      _url += "&DateRange.To=" + dateRangeTo;
    }
    _url += "&IncludeStore=true";
    return this.GET(_url);
  }

  smsSchedules({ pageIndex, pageSize, storeId, status }) {
    let _url = this.serviceUrl + this.endpoints.smsSchedules;
    if (pageIndex) {
      _url += "?pageIndex=" + pageIndex;
    }
    if (pageSize) {
      _url += "&pageSize=" + pageSize;
    }
    if (storeId) {
      _url += "&StoreId=" + storeId;
    }
    if (status || status == 0) {
      _url += "&Status=" + status;
    }
    return this.GET(_url);
  }

  getSmsSchedulesById(id) {
    let _url =
      this.serviceUrl + this.endpoints.smsSchedulesById.replace("{__id__}", id);
    return this.GET(_url);
  }

  smsChangeStatus(data) {
    const _url = this.serviceUrl + this.endpoints.smsChangeStatus;
    return this.POST(_url, data);
  }
}
